import { RegistrationStatus } from '../../enums/registrationStatus';
import { RoleType } from '../../enums/roleType';
import { StageType } from '../../enums/stage';
import { CharacterType, CharacterImageMap } from '../../enums/CharacterType';
import { getClassLabelKey } from '../../utils/utils';

export const isUnregisteredStudent = (state) => {
  return (
    state.role === RoleType.STUDENT &&
    state.registrationStatus === RegistrationStatus.NOT_REGISTERED
  );
};

export const isUnregisteredTeacher = (state) => {
  return (
    (state.role === RoleType.REGULAR_TEACHER || state.role === RoleType.LEAD_TEACHER) &&
    state.registrationStatus === RegistrationStatus.NOT_REGISTERED
  );
};

export const isRegisteredStudent = (state) => {
  return (state.role === RoleType.STUDENT && state.registrationStatus === RegistrationStatus.REGISTERED
  );
};
export const isNotRegisteredStudent = (state) => {
  return (state.role === RoleType.STUDENT && state.registrationStatus === RegistrationStatus.NOT_REGISTERED
  );
};
export const isUnregisteredManager = (state) => {
  return (
    state.role === RoleType.MANAGER &&
    state.registrationStatus === RegistrationStatus.NOT_REGISTERED
  );
};
export const isRegisteredTeacher = (state) => {
  return (
    (state.role === RoleType.REGULAR_TEACHER || state.role === RoleType.LEAD_TEACHER) &&
    state.registrationStatus === RegistrationStatus.REGISTERED
  );
};

export const isRegisteredManager = (state) => {
  return (
    state.role === RoleType.MANAGER &&
    state.registrationStatus === RegistrationStatus.REGISTERED
  );
};

export const isUnregisteredTeacherOrManager = (state) => {
  return isUnregisteredTeacher(state) || isUnregisteredManager(state);
};

export const isRegisteredTeacherOrManager = (state) => {
  return isRegisteredTeacher(state) || isRegisteredManager(state);
};

export const isCurrentStage = (state, stageName) => {
  return state.stage === stageName;
};
export const getFinalStage = (state) => {
  return state?.stages?.find((stage) => stage.name === StageType.FINAL_EVENT);
};
export const isContestStage = (state) => {
  const contestStage = state?.stages?.find((stage) => stage.name === StageType.TRAINING)
  if (contestStage?.isStart
  )
    return true;
  return false;
};

export const isRegistrationStage = (state) => {
  return state.stage === StageType.REGISTRATION || state.stage === null;
};

export const isOpenedDueToEmergency = (state) => {
  const currentContest = state?.activeContests?.find((c) => String(c.id) === String(state?.currentContestId));
  return !!currentContest?.openedDueToEmergency;
};

export const isQualifiersStage = (state) => {
  return state.stage === StageType.TRAINING || state.stage === StageType.ADVANCED;
};

export const isCompetitionEnded = (state) => {
  const schoolCompetitionStage = state?.stages?.find((stage) => stage.name === StageType.SCHOOL_COMPETITION)
  if (schoolCompetitionStage?.isEnd)
    return true;
  return false;
};

export const afterAnnouncement = (state) => {
  const finalistsAnnouncementStage = state?.stages?.find((stage) => stage.name === StageType.FINALISTS)
  if (finalistsAnnouncementStage?.isStart)
    return true;
  return false;
};

export const finalPageAvailable = (state) => {
  return state?.finalData?.isFinalPageAvailable;
};
export const schoolInFinal = (state) => {
  return state?.myFinalStatus?.isSchoolInFinal;
};
export const schoolRegisteredForFinal = (state) => {
  return state?.myFinalStatus?.isSchoolRegisteredForFinal;
};
export const teamMember = (state) => {
  return state?.myFinalStatus?.isTeamMember;
};
export const finalOpen = (state) => {
  return state?.finalData?.isFinalOpen === true;
};
export const isFinalTrainingTeams = (state) => {
  return state?.finalData?.isFinalTrainingTeams;
};
export const finalRegistrationEnd = (state) => {
  return state?.finalData?.finalRegistrationEnd;
};
export const showPublishFinalWinners = (state) => {
  return state?.finalData?.publishFinalWinners;
};
export const isRegistered = (state) => {
  return state.registrationStatus === RegistrationStatus.REGISTERED;
};

export const isNotRegistered = (state) => {
  return state.registrationStatus === RegistrationStatus.NOT_REGISTERED;
};


export const isStudent = (state) => {
  return state.role === RoleType.STUDENT;
};


export const isTeacher = (state) => {
  return state.role === RoleType.REGULAR_TEACHER || state.role === RoleType.LEAD_TEACHER;
};

/**
 * בודק האם המשתמש הוא מורה רגיל
 * @param {Object} state - ה-state של contest
 * @returns {boolean}
 */
export const isRegularTeacher = (state) => {
  return state.role === RoleType.REGULAR_TEACHER;
};

/**
 * בודק האם המשתמש הוא מורה מחנך (מוביל)
 * @param {Object} state - ה-state של contest
 * @returns {boolean}
 */
export const isLeadTeacher = (state) => {
  return state.role === RoleType.LEAD_TEACHER;
};

/**
 * בודק האם המשתמש הוא מנהל
 * @param {Object} state - ה-state של contest
 * @returns {boolean}
 */
export const isManager = (state) => {
  return state.role === RoleType.MANAGER;
};

/**
 * בודק האם המשתמש הוא מורה או מנהל
 * @param {Object} state - ה-state של contest
 * @returns {boolean}
 */
export const isTeacherOrManager = (state) => {
  return isTeacher(state) || isManager(state);
};

/**
 * בודק האם המשתמש מזוהה
 * @param {Object} authState - ה-state של auth
 * @returns {boolean}
 */
export const isIdentified = (authState) => {
  return authState?.isAuth === true;
};

export const userWithoutSchool = (authState) => {
  return authState?.school?.id;
};
/**
 * בודק האם בית הספר רשום
 * @param {Object} state - ה-state של contest
 * @returns {boolean}
 */
export const isSchoolRegistered = (state) => {
  return state.isSchoolRegistered === true;
};

export const itIsMyCompetition = (state, authState) => {
  if (window.config?.hideDuringYearTransition)
    return false;
  const contest = state?.activeContests?.find((c) => String(c.id) === String(state?.currentContestId));
  if(authState?.isAuth === false)
    return true;
  if (authState?.isAuth && !authState?.school?.id)
    return false;
  if (isStudent(state) && !(Number(authState?.userDetails?.grade) >= Number(contest?.fromClass) && Number(authState?.userDetails?.grade) <= Number(contest?.toClass)))
    return false;
  else if (!isStudent(state) && !(authState?.school?.fromClass <= contest?.toClass && authState?.school?.toClass >= contest?.fromClass))
    return false;
  return true;
}


export const isHomeroomTeacher = (school) => {
  return Boolean(school?.mainClasses?.length > 0);
};

export const getHomeroomClass = (school) => {
  const first = school?.mainClasses?.[0];
  return first != null && 'class' in first && 'ordinal' in first ? first : null;
};

export const getHomeroomClassRowId = (school) => {
  const c = getHomeroomClass(school);
  return c != null ? `${c.class}-${c.ordinal}` : null;
};


export const getHomeroomClassDisplayString = (school, texts) => {
  const c = getHomeroomClass(school);
  return c != null ? `${texts[getClassLabelKey(c.class)]}'${c.ordinal}` : null;
};


export const getClassesForDropdown = (type, list = []) => {
  switch (type) {
    case 'main':
      return list.map((c, i) => ({
        id: `${c.class}-${c.ordinal}`,
        classId: c.class,
        ordinal: c.ordinal,
        name: c.name ?? `${c.class}-${c.ordinal}`,
      }));
    case 'school':
      return list.map((c, i) => ({
        id: `${c.classId}-${c.ordinal}`,
        classId: c.classId,
        ordinal: c.ordinal,
        name: c.name ?? `${c.classId}-${c.ordinal}`,
      }));
    default:
      return [];
  }
};

export const getCharacterImagePath = (rank) => {
  const characterRank = Number(rank);
  const characterName = CharacterType[characterRank];
  if (!characterName) {
    return CharacterImageMap[1];
  }
  return CharacterImageMap[characterRank];
};

// export const isSchoolRegisteredToContest = (contest, schoolId) => {
//   if (!contest) return false;

//   if (typeof contest.isSchoolRegistered === 'boolean') {
//     return contest.isSchoolRegistered;
//   }

//   if (schoolId != null && Array.isArray(contest.registeredSchoolIds)) {
//     return contest.registeredSchoolIds.includes(schoolId);
//   }

//   return false;
// };


export const getDefaultContestForStudent = (contests = [], userDetails, schoolId) => {
  const grade = userDetails?.grade;
  return contests?.find((c) => grade >= Number(c.fromClass) && grade <= Number(c.toClass))
};

export const getDefaultContestBySchool = (contests = [], school) => {
  if (!school?.id)
    return null;
  const eligible = contests.filter((c) => school?.fromClass <= c.toClass && school?.toClass >= c.fromClass);
  if (eligible.length === 1)
    return eligible[0];
  else
    return getDefaultContest(eligible);
};

export const getDefaultContest = (cotests = []) => {
  return cotests?.find(c => c.isDefault === true) || cotests[0];
}
